import axiosInstance from "services/AxiosInstance";
import { ResponseType } from "types";

interface PropsPayload {
  filename: string;
  accountId: string;
}

// extend response with the proper type
export const postImportService = async (payload: PropsPayload): Promise<ResponseType<{ id: string }>> => {
  const response = await axiosInstance.post(`imports`, payload);
  return response.data;
};
